import React from 'react';
import { Divider } from '@roo/roo';
import styled from 'styled-components';
import { saveAdditionInfo } from '@assets/apis/innovate';
import { Property } from './property';
import { Honor } from './honor';
import { Credential } from './credential';
import { example_addition } from '../../_utils/example';
import { cols } from '../../_utils/config';
import { useSimpleContext } from '../../_context';
import { FormHok } from '../../_components/FormHok';

const Root = styled.div`
  .form-patch {
    margin-top: 8px;
    width: 634px;
  }
  .form-group {
    & > label {
      text-align: left;
    }
  }
  .field-upload {
    margin-left: 12px;
  }
  .boffin {
    position: relative;
    .delete {
      position: absolute;
      top: -10px;
      right: 100px;
    }
  }
`;

// 附加信息
export const AdditionInfo = function ({ setStep }) {
  const { state } = useSimpleContext((t) => [t.innovate.iniValues, t.disabled]);
  const iniData = state.innovate.iniValues?.additionInfo;
  const formValue = iniData || { ...example_addition };

  return (
    <FormHok
      value={formValue}
      cols={cols}
      disabled={state.disabled}
      alwaysUpdate={false}
      handleSave={saveAdditionInfo}
    >
      {(props) => (
        <Root className="boffin">
          <div className="form-title">
            知识产权情况
            <span className="sub-title">
              若有，请提供不超过5项与项目相关的授权知识产品，包括申报机构所有的专利、软件著作权等可证明技术实力的内容。
            </span>
            <Divider />
          </div>
          <Property {...props} />
          <div className="form-title">
            机构所获荣誉
            <span className="sub-title">若有，请提供机构曾获得的重要荣誉，最多不超过5项。</span>
            <Divider />
          </div>
          <Honor {...props} />
          <div className="form-title">
            其他认为有必要提供的附件及证明文件
            <Divider />
          </div>
          <Credential {...props} />
        </Root>
      )}
    </FormHok>
  );
};
